import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { translate } from '../../../utils/util';

const ReprocessListItem = (props) => {
    return (
        <Link
            style={{ display: 'block', padding: '10px', height: '60px' }}
            to={props.route}
            key={`oi-${props.id}`}
        >
            <span className="sixth-text-color" style={{ display: 'block' }} >
                {props.partNumberCode || ''}
            </span>
            <span className="second-text-color"  >
                {translate('line-picking:linepicking.attempts')}: {props.transmissions?.length || '0'}
            </span>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', marginTop: '-20px', right: '20px', zIndex: '999' }}
            >
                <i className={`mdi mdi-clipboard-check ${!props.adjusted ? 'gray' : 'green'}-text`} />
            </span>
        </Link>
    );
};

export default withRouter(withTranslation()(ReprocessListItem));
